module.exports = __webpack_public_path__ + "static/img/pin-no-spray-inactive.f2fe21a.svg";